export const ASC = 'ASC';
export const DESC = 'DESC';
export const SMALL = 'small';
export const MEDIUM = 'medium';
export const LARGE = 'large';
export const XLARGE = 'xlarge';
export const LOADING_CONTENTS_OPACITY = 0.22;